import PropTypes from 'prop-types'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { FilterCheckbox } from './FilterCheckbox'

export const FilterListCheckbox = ({
  title,
  options,
  onChange,
  onChangeOfChildren,
}) => {
  return (
    <div>
      {title && (
        <Element style={{ color: '#2B457D' }} className={'textUppercase fw600'}>
          <Translate value={title} />
        </Element>
      )}

      {options.map((option, index) => (
        <FilterCheckbox
          key={index}
          option={option}
          onChange={onChange}
          onChangeOfChildren={onChangeOfChildren}
        />
      ))}
    </div>
  )
}

FilterListCheckbox.propTypes = {
  title: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      isChecked: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
    }),
  ).isRequired,
  onChange: PropTypes.func,
  onChangeOfChildren: PropTypes.func,
}

FilterListCheckbox.defaultProps = {
  title: '',
  options: [],
  onChange: () => {},
  onChangeOfChildren: () => {},
}
